import { messages as infoMessages } from 'log_message';
import { messages as errorMessages } from 'error_message';
export const infoResolver = {
    resolve(baseMessage) {
        const messageNum = parseInt(baseMessage);
        return infoMessages[messageNum] || baseMessage;
    }
};
export const errorResolver = {
    resolve(baseMessage) {
        const messageNum = parseInt(baseMessage);
        return errorMessages[messageNum] || baseMessage;
    }
};
export const __platforms = ['__universal__'];
//# sourceMappingURL=message_resolver.js.map